import { render, staticRenderFns } from "./SpaceConfigurationSecrets.vue?vue&type=template&id=735c644c&"
import script from "./SpaceConfigurationSecrets.vue?vue&type=script&lang=js&"
export * from "./SpaceConfigurationSecrets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports